<div class="date-picker">
	<button cdkOverlayOrigin #origin="cdkOverlayOrigin" class="date-picker__trigger" type="button"
		[attr.aria-label]="ariaLabel()" [attr.aria-expanded]="open()" (click)="toggle()">
		<i class="fa-regular fa-calendar" aria-hidden="true"></i>
		<span>{{ label() }}</span>
		<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
	</button>

	<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="open()"
		[cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="date-picker__backdrop"
		(backdropClick)="close()" (detach)="close()">
		<section class="date-picker__panel" [attr.aria-label]="ariaLabel()">
			<header class="date-picker__header">
				<button type="button" (click)="previousMonth()" aria-label="Vorige maand">
					<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
				</button>
				<strong>{{ monthLabel() }}</strong>
				<button type="button" (click)="nextMonth()" aria-label="Volgende maand">
					<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
				</button>
			</header>

			<div class="date-picker__weekdays">
				@for (weekDay of weekDays; track weekDay) {
					<span>{{ weekDay }}</span>
				}
			</div>

			<div class="date-picker__grid">
				@for (day of days(); track day.toISOString()) {
					<button type="button" [class.date-picker__day--outside]="isOutsideMonth(day)"
						[class.date-picker__day--disabled]="isDisabled(day)" [class.date-picker__day--selected]="isSelected(day)"
						[disabled]="isDisabled(day)" [attr.aria-pressed]="isSelected(day)"
						[attr.aria-label]="formatAccessible(day)" (click)="selectDay(day)">
						{{ day.getDate() }}
					</button>
				}
			</div>
		</section>
	</ng-template>
</div>
